import { Router } from 'express';
import * as controller from './teams.controller';
import { authMiddleware } from '../../middleware/auth.middleware';
import { requireRole } from '../../middleware/rbac.middleware';

const router = Router();
router.use(authMiddleware);

router.get('/', controller.list);
router.post('/', requireRole('admin', 'super_admin'), controller.create);
router.get('/:id', controller.getOne);
router.post('/:id/members', requireRole('admin', 'super_admin'), controller.addMember);
router.delete('/:id/members/:userId', requireRole('admin', 'super_admin'), controller.removeMember);
router.patch('/:id', requireRole('admin', 'super_admin'), controller.update);
router.delete('/:id', requireRole('admin', 'super_admin'), controller.remove);

export default router;
